/* eslint-disable @typescript-eslint/ban-types */

export enum FieldType {
    Carousel = 'carousel',
    Range = 'range',
    MultiSelect = 'multiselect',
    SingleSelect = 'singleselect',
    NumberInput = 'numberinput',
}

interface Option {
    answerText: string;
    value: number | string;
}

interface SingleSelectOption {
    answerText: string;
    value: string;
}

interface QuestionBase {
    questionKey: string;
    questionText: string;
    optional: boolean;
    type: FieldType;
    responseType: Option[];
    displayCrisisWarning: boolean;
    subQuestions?: Question[];
}

export interface MultiSelectQuestion extends QuestionBase {
    keyword: string;
}

export interface SingleSelectQuestion extends QuestionBase {
    responseType: SingleSelectOption[];
}

export enum FlowType {
    INITIAL_ONBOARDING = 'INITIAL_ONBOARDING',
    RETRIAGE = 'RETRIAGE',
    LEGACY_PROGRAM = 'LEGACY_PROGRAM',
    MEMBER_WEB_SETTINGS = 'MEMBER_WEB_SETTINGS',
    PRE_SESSION = 'PRE_SESSION',
}

export type Question = MultiSelectQuestion | SingleSelectQuestion;

export type Answer = string | number | string[] | null; //null is value for skipped value

export type MappedAnswers = Record<string, Answer>;

export interface Assessment {
    id: number;
    name: string;
    headerText: string;
    assessmentQuestions: Question[];
}

export type MappedScores = Record<string, number | undefined>;

export interface AssessmentsState {
    assessments: object;
    scores: MappedScores;
    mostRecentAssessmentDate: string;
}

export enum AssessmentType {
    Who5 = 'who5',
    Phq2 = 'phq2',
    Gad2 = 'gad2',
    Phq8 = 'phq8',
    Phq8Remainder = 'phq8_remainder',
    Phq9 = 'phq9',
    Phq9Remainder = 'phq9_remainder',
    Gad7 = 'gad7',
    Gad7Remainder = 'gad7_remainder',
    EmploymentHealth = 'employment_health',
}

export const WhoTypes = [AssessmentType.Who5];
export const PhqTypes = [
    AssessmentType.Phq2,
    AssessmentType.Phq8,
    AssessmentType.Phq8Remainder,
    AssessmentType.Phq9,
    AssessmentType.Phq9Remainder,
];
export const GadTypes = [AssessmentType.Gad2, AssessmentType.Gad7, AssessmentType.Gad7Remainder];

export enum AssessmentTestId {
    PreviousQuestion = 'PreviousQuestion',
    NextQuestion = 'NextQuestion',
    ImmediateCrisisSupportButton = 'ImmediateCrisisSupportButton',
    QuestionContainer = 'QuestionContainer',
}
